import { useState } from "react";
import { isPreviewEnvironment, LIVE_ORIGIN } from "../lib/previewEnv";

// Το panel του Emergent ανοίγει ΠΑΝΤΑ την αρχική (/) — από εδώ πας κατευθείαν στη σελίδα που θες.
const PREVIEW_PAGES = [
  { label: "📋 Brief συνεργάτη social (νέο)", href: "/brief-synergati.html" },
  { label: "📄 Σελίδα αποτελεσμάτων (δοκιμή) → «Ναι, πολύ»", href: "/r/demo-results-preview#feedback" },
  { label: "📞 Παράθυρο «Πότε να σε καλέσω;» (δοκιμή)", href: "/demo-klisi" },
  { label: "❤️ Άμεση Συνοχή (εργαλείο)", href: "/synoxi?preview=1" },
  { label: "🌅 Πρακτική", href: "/praktiki?preview=1" },
  { label: "🏋️ Γυμναστήριο", href: "/gymnastirio?preview=1" },
  { label: "🔎 Ανάλυση Πειρατή Β", href: "/analisiB?preview=1" },
  { label: "📚 Ύλη ομάδας (admin /8w01)", href: "/8w01" },
  { label: "🛠 Admin", href: "/admin" },
  { label: "⚓ Κοινότητα (σύνδεση μέλους)", href: "/koinotita?preview=1" },
];

// Η σελίδα που δουλεύουμε ΤΩΡΑ — μεγάλο κίτρινο κουμπί σε κάθε σελίδα του preview (το panel ανοίγει πάντα το /)
const PREVIEW_FOCUS = { label: "Brief συνεργάτη social", path: "/brief-synergati.html", href: "/brief-synergati.html" };

export default function PreviewEnvBanner() {
  const [hidden, setHidden] = useState(false);
  if (!isPreviewEnvironment() || hidden) return null;
  const live = `${LIVE_ORIGIN}${window.location.pathname}${window.location.search}`;
  const onFocus = window.location.pathname.replace(/\/$/, "") === PREVIEW_FOCUS.path;
  return (
    <div className="fixed top-0 inset-x-0 z-[200] bg-rose-600 text-white text-[12px] sm:text-sm font-bold px-3 py-1.5 flex items-center gap-2 shadow-lg flex-wrap" data-testid="preview-env-banner">
      <span className="shrink-0">⚠️ PREVIEW</span>
      {!onFocus && (
        <a href={PREVIEW_FOCUS.href} className="basis-full sm:basis-auto sm:order-last text-center rounded-lg bg-amber-400 text-slate-900 px-3 py-2 text-sm font-black shadow hover:bg-amber-300" data-testid="preview-env-focus">
          ▶ ΔΕΣ ΤΗ ΝΕΑ ΑΛΛΑΓΗ: {PREVIEW_FOCUS.label}
        </a>
      )}
      <select
        value=""
        onChange={(e) => { if (e.target.value) window.location.href = e.target.value; }}
        className="flex-1 min-w-0 max-w-[260px] rounded-md bg-white text-slate-900 text-xs font-bold px-2 py-1"
        aria-label="Πήγαινε σε σελίδα"
        data-testid="preview-env-goto"
      >
        <option value="">📍 Πήγαινε σε… (δοκιμή νέων)</option>
        {PREVIEW_PAGES.map((p) => <option key={p.href} value={p.href}>{p.label}</option>)}
      </select>
      <span className="hidden md:inline flex-1 min-w-0 truncate font-semibold">Δοκιμαστικό αντίγραφο με ΔΙΚΗ του βάση — ΔΕΝ δείχνει την ύλη του live.</span>
      <a href={live} className="shrink-0 underline hover:text-rose-100" data-testid="preview-env-live-link">Live →</a>
      <button type="button" onClick={() => setHidden(true)} className="shrink-0 px-1.5 text-white/80 hover:text-white" aria-label="Κλείσιμο" data-testid="preview-env-close">✕</button>
    </div>
  );
}
